export default {
  // 页面标题
  'pages.tenant.store.title': '门店管理',
  'pages.tenant.store.subtitle': '管理租户门店信息、地址配置及营业状态',
  'pages.tenant.store.addTitle': '新增门店',
  'pages.tenant.store.editTitle': '编辑门店',

  // 按钮
  'pages.tenant.store.addStore': '新增门店',
  'pages.tenant.store.export': '导出',
  'pages.tenant.store.cancel': '取消',
  'pages.tenant.store.save': '保存',
  'pages.tenant.store.edit': '编辑',

  // 提示消息
  'pages.tenant.store.message.exportDeveloping': '导出功能开发中...',
  'pages.tenant.store.exportFileName': '门店列表',
  'pages.tenant.store.message.exportSuccess': '导出成功',
  'pages.tenant.store.message.exportFailed': '导出失败',
  'pages.tenant.store.message.addSuccess': '新增成功',
  'pages.tenant.store.message.editSuccess': '编辑成功',

  // 搜索
  'pages.tenant.store.search.placeholder': '搜索门店名称、门店编码、负责人',

  // 表格列
  'pages.tenant.store.column.storeType': '门店类型',
  'pages.tenant.store.column.storeId': '门店ID',
  'pages.tenant.store.column.storeCode': '门店编码',
  'pages.tenant.store.column.storeName': '门店名称',
  'pages.tenant.store.column.tenant': '所属租户',
  'pages.tenant.store.column.address': '门店地址',
  'pages.tenant.store.column.contact': '店长 / 电话',
  'pages.tenant.store.column.deviceCount': '设备数',
  'pages.tenant.store.column.taxType': '税务类型',
  'pages.tenant.store.column.storeStatus': '门店状态',
  'pages.tenant.store.column.createTime': '创建时间',
  'pages.tenant.store.column.action': '操作',

  // 下拉占位
  'pages.tenant.store.placeholder.selectStoreType': '请选择门店类型',
  'pages.tenant.store.placeholder.selectStoreStatus': '请选择门店状态',

  // 卡片标题
  'pages.tenant.store.card.storeInfo': '门店信息',
  'pages.tenant.store.card.taxInfo': '税务信息(BIR合规)',
  'pages.tenant.store.card.serviceFee': '服务费配置',
  'pages.tenant.store.card.localTax': 'Local tax 配置',
  'pages.tenant.store.card.brandConfig': '品牌与展示配置',

  // 表单 - 门店信息
  'pages.tenant.store.form.tenant': '所属租户',
  'pages.tenant.store.form.tenantPlaceholder': '请选择租户',
  'pages.tenant.store.form.tenantRequired': '请选择租户',
  'pages.tenant.store.form.storeName': '门店名称',
  'pages.tenant.store.form.storeNameRequired': '请输入门店名称',
  'pages.tenant.store.form.storeType': '门店类型',
  'pages.tenant.store.form.storeTypePlaceholder': '请选择门店类型',
  'pages.tenant.store.form.storeTypeRequired': '请选择门店类型',
  'pages.tenant.store.form.area': '门店区域',
  'pages.tenant.store.form.areaPlaceholder': '请选择区域',
  'pages.tenant.store.form.areaRequired': '请选择门店区域',
  'pages.tenant.store.form.storeStatus': '门店状态',
  'pages.tenant.store.form.storeStatusPlaceholder': '请选择门店状态',
  'pages.tenant.store.form.storeStatusRequired': '请选择门店状态',
  'pages.tenant.store.form.contactName': '店长姓名',
  'pages.tenant.store.form.contactNameRequired': '请输入店长姓名',
  'pages.tenant.store.form.contactPhone': '店长电话',
  'pages.tenant.store.form.contactPhoneRequired': '请输入店长电话',
  'pages.tenant.store.form.contactPhonePattern':
    '请输入正确的菲律宾手机号码格式',
  'pages.tenant.store.form.businessHours': '营业时间',
  'pages.tenant.store.form.businessHoursRequired': '请选择营业时间',
  'pages.tenant.store.form.startTime': '开始时间',
  'pages.tenant.store.form.endTime': '结束时间',
  'pages.tenant.store.form.address': '门店地址',
  'pages.tenant.store.form.addressRequired': '请输入门店地址',

  // 表单 - 税务信息
  'pages.tenant.store.form.companyName': '公司法定名称',
  'pages.tenant.store.form.tinNumber': 'TIN号码',
  'pages.tenant.store.form.taxType': '税务类型',
  'pages.tenant.store.form.taxTypePlaceholder': '请选择税务类型',
  'pages.tenant.store.form.taxTypeRequired': '请选择税务类型',
  'pages.tenant.store.form.taxAddress': '税务地址',

  // 表单 - 服务费配置
  'pages.tenant.store.form.serviceFeeSwitch': '服务费规则开关',
  'pages.tenant.store.form.enabled': '已启用',
  'pages.tenant.store.form.disabled': '未启用',
  'pages.tenant.store.form.serviceFeeType': '服务费类型',
  'pages.tenant.store.form.percentageValue': '百分比值',
  'pages.tenant.store.form.percentageValueRequired': '请输入百分比值',
  'pages.tenant.store.form.percentageValueRange': '百分比值需为 1~99 的整数',
  'pages.tenant.store.form.transactionType': '收取服务费交易类型',
  'pages.tenant.store.form.transactionTypeRequired': '请选择收取服务费交易类型',
  'pages.tenant.store.form.serviceFeeHint':
    '启用服务费功能后，可配置服务费收取方式',

  // 表单 - Local tax 配置(2026-10-28 新增,镜像服务费配置;总部端专属,租户端不开放)
  'pages.tenant.store.form.localTaxSwitch': 'Local tax 规则开关',
  'pages.tenant.store.form.localTaxType': 'Local tax 类型',
  'pages.tenant.store.form.localTaxTransactionType': '收取 Local tax 交易类型',
  'pages.tenant.store.form.localTaxTransactionTypeRequired':
    '请选择收取 Local tax 交易类型',
  'pages.tenant.store.form.localTaxHint':
    '启用 Local tax 功能后，可配置 Local tax 收取方式',

  // 表单 - 品牌与展示配置
  'pages.tenant.store.form.storeLogo': '门店logo',
  'pages.tenant.store.form.uploadLogo': '请上传LOGO图片文件',
  'pages.tenant.store.form.logoHint':
    '支持 JPG、PNG 格式，建议尺寸 200x200 像素',
  'pages.tenant.store.form.secondaryScreen': '副屏配置显示',

  // 通用
  'pages.tenant.store.form.input': '请输入',
};
